import { Box, Grid, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { GET_QUERY_KEY, INITIAL_PAGE_SIZE } from "../../../common/constants";
import { setSelectedTaxYear, setUserMenuOpen } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { AdjustmentOptionsService } from "../../../services/AdjustmentOptionsService";
import { BackdropCircularProgress } from "@websential/cosmic";
import { DashboardPanels } from "./DashboardPanels";
import { DashboardServices } from "../../../services/common/DashboardServices";
import ExposureIcon from "@mui/icons-material/Exposure";
import { FilingResourceService } from "../../../services/FilingResourceService";
import { GuidPanelList } from "./GuidPanelList";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { RL1SlipService } from "../../../services/RL1SlipService";
import { ResourceService } from "../../../services/ResourceService";
import { T4ASlipService } from "../../../services/T4ASlipService";
import { T4SlipService } from "../../../services/T4SlipService";
import { TaxSlipYearService } from "../../../services";
import { clearSelectedResourceApiMessageActions } from "../../../store/actions/resourceApiMessageActions";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedDashboardApisData } from "../../../store/actions/dashboardApisDataActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { useNavigate } from "react-router-dom";

const DASHBOARD_API_DATA_QUERY_KEY = `dashboard-counts`
const DASHBOARD_GET_DIFFERENT_API_DATA_QUERY_KEY = `dashboard-api`

const useTaxYearByClient = (
  clientId: string
) =>
  useQuery({
    queryKey: ["year"],
    queryFn: (data) => {
      return TaxSlipYearService.getYear(clientId);
    },
    refetchOnWindowFocus: false
  });

// DASHBOARD API
const useGetAllCounts = (
  clientId: string,
  taxYear: number | null
) =>
  useQuery({
    queryKey: [DASHBOARD_API_DATA_QUERY_KEY, clientId, taxYear],
    queryFn: (data) => {
      return DashboardServices.getAllCounts(clientId, taxYear);
    },
    refetchOnWindowFocus: false
  });

// Taxslip Year List
// let totalYears: any = []
// const useYears = (params: IGetListRequest) =>
//   useQuery({
//     queryKey: ["years-list", params],
//     queryFn: (data) => {
//       return TaxSlipYearService.getList(params);
//     },
//     refetchOnWindowFocus: false
//   });

//adjustment options get call by client id and taxyear
const GET_ADJUSTMENT_OPTIONS_QUERY_KEY = "get-adjustment-options";
// const useAdjustmentOptions = (
const useGetDifferentApisData = (
  clientId: string, taxYear: number | null
) =>
  useQuery({
    queryKey: [GET_ADJUSTMENT_OPTIONS_QUERY_KEY, clientId, taxYear],
    queryFn: (data) => {
      return DashboardServices.getAllCombineYearlyData(clientId, taxYear);
    },
    refetchOnWindowFocus: false
  });

export const ClientDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useSelector((state: IAppState) => state.client);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  // const [year, setYear] = useState(new Date().getFullYear().toString());
  const queryClient = useQueryClient();

  const [year, setYear] = useState<any>(null);


  // all counts recieved here 
  const { isPending: isLoadingDashboardCounters, data: dashboardCounters } = useGetAllCounts(id, year);
  const counts: any = dashboardCounters;
  // console.log('counts-=-=-=', counts)
  // all counts recieved here 
  const dashboardApi = useGetDifferentApisData(id, year);
  const dashboardApiData: any = dashboardApi.data;
  // console.log('dashboardApiData-=-=-=', dashboardApiData)

  useEffect(() => {
    if (counts && counts.message && counts.message.detail === "Invalid token or expired token.") {
      let path = '/logout'
      navigate(path)
    }
    if (dashboardApiData) {
      dispatch(setSelectedDashboardApisData(dashboardApiData));
    }
  }, [counts, dashboardApiData])


  // resources
  //   // employee
  const [queryParams] = useState<IGetListRequest>({
    search_query: "",
    order_by: "name",
    order_direction: "asc",
    page: 1,
    size: INITIAL_PAGE_SIZE,
  });
  //   const employeeData = useResources(id, String(EmpReasource), queryParams);
  //   const empData: any = employeeData.data;

  //   if (empData !== undefined) {
  //     totalEmployees = empData.total;

  //   }

  //   // vendor
  //   const dataVendor = useResourcesVendor(
  //     id,
  //     String(vendorReasource),
  //     queryParams
  //   );
  //   const vendorData: any = dataVendor.data;

  //   if (vendorData !== undefined) {
  //     totalVendor = vendorData.total;

  //   }

  //   // Filling Resource
  //   const [queryParamsFR] = useState<IGetListRequest>({
  //     search_query: "",
  //     order_by: "role_name",
  //     order_direction: "asc",
  //     page: 1,
  //     size: 25,
  //   });
  //   const dataFR = useFilingResources(id, queryParamsFR);
  //   const listRecords: any = dataFR.data;

  //   if (listRecords !== undefined) {
  //     totalFR = listRecords.total;

  //   }

  // // T4 slip
  //   const T4SlipData  = useT4Slips(id, year, queryParams);
  //   const t4SlipList: any = T4SlipData.data;

  //   if (t4SlipList !== undefined) {
  //     // totalT4Slips = t4SlipList.total;
  //     const filteredOnlySlipsIds = t4SlipList && t4SlipList.items.filter((item:any) => item.id.length === 24);

  //     totalT4Slips = filteredOnlySlipsIds && filteredOnlySlipsIds.length;

  //   }

  //   // T4A slips
  //   const t4aSlipData = useT4ASlips(id, year, queryParams);
  //   const t4aSlipList: any = t4aSlipData.data;

  //   if (t4aSlipList !== undefined) {
  //     // totalT4aSlips = t4aSlipList.total;
  //     const filteredOnlySlipsIds = t4aSlipList && t4aSlipList.items.filter((item:any) => item.id.length === 24);

  //     totalT4aSlips = filteredOnlySlipsIds && filteredOnlySlipsIds.length;

  //   }

  //   // RL-1 slips
  //   const rl1SlipData  = useRl1Slips(id, year, queryParams);
  //   const rl1SlipList: any = rl1SlipData.data;

  //   if (rl1SlipList !== undefined) {
  //     if(rl1SlipList && rl1SlipList.total){
  //       // totalRl1Slips = rl1SlipList.total;
  //       const filteredOnlySlipsIds = rl1SlipList && rl1SlipList.items.filter((item:any) => item.id.length === 24);
  //       totalRl1Slips = filteredOnlySlipsIds && filteredOnlySlipsIds.length;
  //       
  //   
  //     } else if (rl1SlipList && rl1SlipList.message && rl1SlipList.message.message === 'No Quebec employees found'){
  //       totalRl1Slips = 0;
  //     }
  //   }

  // Taxslip Year list
  // const yearListData = useYears(queryParams);
  // const yearsList: any = yearListData.data;

  // if (counts && counts.years_list !== undefined) {
  //   totalYears = counts.years_list;

  // }

  // Adjustment OPtions
  // const adjustmentOptions = useAdjustmentOptions(id, year);
  // const adjustmentOptionsData: any = adjustmentOptions.data;



  const [isYearLoading, setIsYearLoading] = useState(false)
  let loading = false
  // Taxslip Currernt Year by Client
  const { isPending: isLoadingYear, data: yearGet } = useTaxYearByClient(id);
  const currentYear: any = yearGet;

  // let yearSelected = ''
  // if (counts && counts.years_client_ddl !== undefined) {

  //   dispatch(setSelectedTaxYear({ year: counts.years_client_ddl.taxYear }));
  //   // yearSelected = counts.years_client_ddl.taxYear
  //   //  setYear(currentYear.taxYear)
  // }

  useEffect(() => {
    if (currentYear) {
      dispatch(setSelectedTaxYear({ year: currentYear.taxYear }));
      setYear(currentYear.taxYear)
    }
  }, [currentYear])

  const simplePanels = [
    {
      icon: (
        <PersonOutlineIcon
          sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
        />
      ),
      title: "Employees",
      navigateTo: "/resources/Employee/list",
      count: counts && counts.totalEmployee,
    },
    {
      icon: (
        <PersonOutlineIcon
          sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
        />
      ),
      title: "Vendors",
      navigateTo: "/resources/Vendor/list",
      count: counts && counts.totalVendor,
    },
    {
      icon: (
        <PersonOutlineIcon
          sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
        />
      ),
      title: "T5 Recipients",
      navigateTo: "/resources/T5_Recipient/list",
      count: counts && counts.totalT5Recipient,
    },
    {
      icon: (
        <PersonOutlineIcon
          sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
        />
      ),
      title: "T3 Beneficiary",
      navigateTo: "/resources/T3_Benificiary/list",
      count: counts && counts.totalT3Beneficiary,
    },
    // {
    //   icon: (
    //     <PeopleOutlineIcon
    //       sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
    //     />
    //   ),
    //   title: "Filling Resource",
    //   navigateTo: "/filing-resources/list",
    //   count: counts && counts.fillingResourceTotal,
    // },

    //show two panels in one panel
    // {
    //   jointPanels:[
    //     {
    //       icon: (
    //         <ExposureIcon sx={{ color: "rgb(0, 82, 204)", fontSize: "40px",marginTop:"-2.5px" }} />
    //         ),
    //         title: "Potential Adjustment & Correction",
    //         navigateTo: "/audit/pier-review",
    //         divider:true
    //     },
    //     {
    //       icon: (
    //         <PeopleOutlineIcon
    //           sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
    //         />
    //       ),
    //       title: "Users",
    //       navigateTo: "/invite/user",
    //     },
    //   ]
    // }
  ];

  const simplePanelsSecondList = [
    {
      icon: (
        <ExposureIcon sx={{ color: "rgb(0, 82, 204)", fontSize: "40px", marginTop: "-2.5px" }} />
      ),
      title: "Potential Adjustment & Correction",
      navigateTo: "/audit/pier-review",
    },
    {
      icon: (
        <PeopleOutlineIcon
          sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
        />
      ),
      title: "Users",
      navigateTo: "/invite/user",
    },
    {
      icon: (
        <PeopleOutlineIcon
          sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
        />
      ),
      title: "Filling Resource",
      navigateTo: "/filing-resources/list",
      count: counts && counts.fillingResourceTotal,
    },
  ];

  const summariesList = [
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T4 Summary",
      navigateTo: "/taxslip/t4/summary",
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T4A Summary",
      navigateTo: "/taxslip/t4a/summary",
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/rq_flag.a7be73f.png",
      title: "RL-1 Summary",
      navigateTo: "/taxslip/rl1/summary",
    },
  ];
  const secondSummariesList = [
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T5 Summary",
      navigateTo: "/taxslip/t5/summary",
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T3 Summary",
      navigateTo: "/taxslip/t3/summary",
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/rq_flag.a7be73f.png",
      title: "RL-3 Summary",
      navigateTo: "/taxslip/rl3/summary",
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/rq_flag.a7be73f.png",
      title: "RL-16 Summary",
      navigateTo: "/taxslip/rl16/summary",
    },
  ];
  const slipsList = [
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T4",
      navigateTo: "/taxslip/t4/list",
      slipCount: counts && counts.t4TotalSlip,
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T4A",
      navigateTo: "/taxslip/t4a/list",
      slipCount: counts && counts.t4aTotalSlip,
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/rq_flag.a7be73f.png",
      title: "RL-1",
      navigateTo: "/taxslip/rl1/list",
      slipCount: counts && counts.rl1TotalSlip,
    },
  ];
  const secondSlipsList = [
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T5",
      navigateTo: "/taxslip/t5/list",
      slipCount: counts && counts.t5TotalSlip,
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/cra_flag.3b01a4d.png",
      title: "T3",
      navigateTo: "/taxslip/t3/list",
      slipCount: counts && counts.t3TotalSlip,
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/rq_flag.a7be73f.png",
      title: "RL-3",
      navigateTo: "/taxslip/rl3/list",
      slipCount: counts && counts.rl3TotalSlip,
    },
    {
      icon: "https://app.taxslips.com/_nuxt/img/rq_flag.a7be73f.png",
      title: "RL-16",
      navigateTo: "/taxslip/rl16/list",
      slipCount: counts && counts.rl16TotalSlip,
    },
  ];
  const guidPanels = {
    items: [
      {
        title: "Tax Slips Guide",
        color: "#2196f3",
        // navigateTo: "https://v3.taxslips.com/guides/#/general-guide",
        navigateTo: "https://taxslips.com/guides/#/general-guide",
      },
      {
        title: "T4 Guide",
        color: "#ffc107",
        // navigateTo: "https://v3.taxslips.com/guides/#/t4-guide",
        navigateTo: "https://taxslips.com/guides/#/t4-guide",
      },
      {
        title: "T4A Guide",
        color: "#f44336",
        // navigateTo: "https://v3.taxslips.com/guides/#/t4a-guide",
        navigateTo: "https://taxslips.com/guides/#/t4a-guide",
      },
      {
        title: "RL-1 Guide",
        color: "#4caf50",
        // navigateTo: "https://v3.taxslips.com/guides/#/rl1-guide",
        navigateTo: "https://taxslips.com/guides/#/rl1-guide",
      },
      {
        title: "T5 Guide",
        color: "#2196f3",
        navigateTo: "https://taxslips.com/guides/#/t5-guide",
      },
      {
        title: "RL-3 Guide",
        color: "#ffc107",
        navigateTo: "https://taxslips.com/guides/#/rl3-guide",
      },
      {
        title: "T3 Guide",
        color: "#f44336",
        navigateTo: "https://taxslips.com/guides/#/t3-guide",
      },
      {
        title: "RL-16 Guide",
        color: "#4caf50",
        navigateTo: "https://taxslips.com/guides/#/rl16-guide",
      },
    ],
  };
  const [nextFebruaryDate, setNextFebruaryDate] = useState('');
  const calculateNextFebruaryDate = (selectedYear:number | null) => {
    // const nextYear: any = yearSelected + 1;
    if (selectedYear) {
      const nextYear: any = selectedYear + 1;
      const isLeapYear = (nextYear % 4 === 0 && nextYear % 100 !== 0) || nextYear % 400 === 0;
      const febLast = isLeapYear ? 29 : 28;

      setNextFebruaryDate(`${febLast} Feb ${nextYear}`);
    }
  };

  {/* this is used when filing resource and filingdeadline use in same panel and seperate with seperator line */ }
  //   const deadLine = [
  //     {
  //       icon: (
  //         <PeopleOutlineIcon
  //           sx={{ color: "rgb(0, 82, 204)", fontSize: "40px" }}
  //         />
  //       ),
  //       title: "Filling Resource",
  //       navigateTo: "/filing-resources/list",
  //       count: counts && counts.fillingResourceTotal,
  //       divider:true
  //     },
  //     {
  //       title: "Filing Deadline",
  //       date: nextFebruaryDate,
  //     }
  // ];
  const deadLine = {
    title: "Filing Deadline",
    date: nextFebruaryDate,
  }

  // const useGetYearList = () =>
  // useQuery(
  //   GET_QUERY_KEY.YEAR_DDL,
  //   () => TaxSlipYearService.getListDDL(),
  //   QUERY_OPTIONS
  // );
  // const { isPending: isLoadingYearDDL, data: yearList } = useYears(queryParamsFR);
  // const [selectedYear, setSelectedYear] = useState(2022);

  // const onYearSelectionChangeHandler = (item: IEnhancedDropDownItem) => {
  //   setSelectedYear(Number(item.label));
  // };

  // let isLoading = false
  const [isLoadingSelect, setIsLoadingSelect] = useState(false)

  const handleChange = async (event: SelectChangeEvent): Promise<void> => {
    // alert(event.target.value)
    // setYear(event.target.value);
    try {
      setIsYearLoading(true)
      // setYear(Number(event.target.value));
      // yearSelected = event.target.value
      // setIsLoadingSelect(true)
      // setTimeout(() => {
      //   setIsLoadingSelect(false);
      // }, 1000);
      const response = await TaxSlipYearService.PutTaxYear(id, Number(event.target.value));
      if(response){
        dispatch(setSelectedTaxYear({ year: response.taxYear }));
        setYear(response.taxYear);
      }
      // refetchCurrentYear()
      // queryClient.invalidateQueries({ queryKey: [DASHBOARD_API_DATA_QUERY_KEY] });

      // window.location.reload()
      // window.location.href = "/clients/dashboard";
    } catch (err) {

      alert(err)
    } finally {
      setIsYearLoading(false)
    }
  };



  // const handleChange = (event: SelectChangeEvent) => {

  //   setYear(Number(event.target.value));
  //   dispatch(setSelectedTaxYear({year:Number(event.target.value)}));
  //   // isLoading=true
  //   setIsLoadingSelect(true)
  //   setTimeout(() => {
  //     setIsLoadingSelect(false);
  //   }, 1000);
  // };

  // const yearItems = useMemo(() => {
  //   if (yearsList !== undefined && yearsList) {
  //     return yearsList.items.map((yearItem:any) => ({
  //       label: String(yearItem.year),
  //       value: yearItem.id,
  //     }));
  //   }
  // }, [yearsList]);



  // const schema = yup.object().shape({
  //   year: yup
  //     .string()
  //     .typeError("Please select your feeling.")
  //     .required("Please select your feeling."),
  // });
  // const methods = useForm({ resolver: yupResolver(schema) });

  useEffect(() => {
    // setIsYearLoading(true)
    // setTimeout(() => {
    //   setIsYearLoading(false);
    // }, 1500);
    calculateNextFebruaryDate(year);
    // if (yearSelected !== "") {
    //   setYear(Number(yearSelected))
    // }
  }, [year])

  //defualt drawer options set in home 
  useEffect(() => {
    const homeDrawerOptionsOpen = { id: 10000, text: "Home" }
    dispatch(setUserMenuOpen(homeDrawerOptionsOpen));
    dispatch(clearSelectedResourceApiMessageActions())
    // window.location.href = "/clients/dashboard";
    // window.location.href = "/";
  }, []);

  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: "",
        entityId2: "",
        entityId3: "",
        screenName: '',
        companyName: '',
        activityType:
          "",
        activityLogVisibility: false,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: false }));
  }, []);



  return (
    <>
      <BackdropCircularProgress
        open={
          // isLoading ||
          // isLoadingYearDDL
          isYearLoading ||
          isLoadingSelect ||
          // || loading
          isLoadingYear ||
          isLoadingDashboardCounters
        }
        testId="client-dashboard-backdrop"
      />
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        sx={{ margin: "0 2.5rem 0 3rem" }}
      >
        <Grid
          size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          sx={{ p: "0 10px 1rem 0", }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "flex-end" }}>
            <InputLabel
              id="demo-simple-select-label"
              sx={{ marginRight: '20px' }} // Adjust the positioning of the label
            >
              Filling Year
            </InputLabel>
            <Select
              test-Id="year-simple-select"
              value={year}
              onChange={handleChange}
              sx={{ width: "200px", height: "2.5rem" }}
            >
              {counts && counts.years_list !== undefined && counts.years_list.map((option: any) => (
                <MenuItem key={option.year} value={option.year}>
                  {option.year}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>
        {/* <EnhancedDropDownWithLabel
        selectName="selectedItemDDL"
        items={yearsList.items}
        onChangeHandler={handleChange}
        selectedItem={year}
        testId="enhancedDropDownSelectedList"
        label='Fruits'
        labelPosition={LabelPosition.Left}
      /> */}
        {/* <FormProvider {...methods}>
                <EnhancedDropDownRHFWithLabel
                  selectName="year"
                  label="Select Year"
                  labelPosition={LabelPosition.Left}
                  items={yearItems ? yearItems : []}
                  testId=""
                  onSelectionChangeHandler={onYearSelectionChangeHandler}
                />
        </FormProvider> */}
        <DashboardPanels
          panel={simplePanels}
          panelSecondlist={simplePanelsSecondList}
          summaryList={summariesList}
          summarySecondList={secondSummariesList}
          slip={slipsList}
          slipSecondList={secondSlipsList}
          deadline={deadLine}
        />
        <GuidPanelList {...guidPanels} />
      </Grid>
    </>
  );
};
